import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

// Stores only the chosen project filter (a display name) so the view survives a reload.
// No tokens or personal data: authentication lives in httpOnly cookies.
const STORAGE_KEY = "koioc.projectFilter";
const ProjectContext = createContext({ project: "", setProject: () => {}, projects: [] });

export function ProjectProvider({ children }) {
  const [project, setProjectState] = useState(() => localStorage.getItem(STORAGE_KEY) || "");
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api
      .get("/projects")
      .then(({ data }) => setProjects((data.projects || []).filter((p) => p.connected)))
      .catch(() => setProjects([]));
  }, []);

  const setProject = (name) => {
    setProjectState(name);
    if (name) localStorage.setItem(STORAGE_KEY, name);
    else localStorage.removeItem(STORAGE_KEY);
  };

  const value = useMemo(() => ({ project, setProject, projects }), [project, projects]);
  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

export function useProject() {
  return useContext(ProjectContext);
}
